import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { AddBankModel, EditDataModel, GenDeviceModel, LoginQRCodeCard } from "../../components/Model/add-model";
import { TrueWalletGuide } from "../../components/Guide/truewallet-guide";
import { BankOutlined, FilterOutlined, } from "@ant-design/icons";
import { Button, Card, Spin, Space, Select, Flex, Modal, } from "antd";
import { t } from "i18next";
import AppContext from "../../components/AppContext";
import DetailsBank from "./DetailsBank";
import Apisetting from "../../api/Apisetting";
import { withTranslation } from "react-i18next";
import {
  confirmSwal,
  getNextMinute,
  hasPermission,
  openNotification,
  sendApiTelegram_activity,
  sendApiTelegram_activity_Support,
  showToast,
  StringTimeLeft,
  SwalInputConfirm,
} from "../../utils";
import { ColumnsCurrent, ColumnsVerify, ColumnsRepair, ColumnsSuspended, } from "../../components/Columns/columns-bank-account";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
import { getFuncBalance } from "../../utils/funcCallback";
import { CheckAdminType, } from "../../helpers/checkPermission";
import Apibank from "../../api/Apibank";
import { renderContentList, renderTabtList } from "./components/contentList";
import { debounce } from "lodash";
import { FooterBankAccount } from "../../components/Footer";
import { ComponentSearch } from "./components/index.component";
import { getCookie } from "../../utils/cookieHelper";
import { CONFIGMERCHENTID } from "../../Data/configMerchant";

class ManageBankAccount extends React.Component {
  static contextType = AppContext;
  instance = null;
  style = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.instance = null;

    this.state = {
      // UI States
      activeTabKey1: "tab1",
      keyTabSearch: "tab6",
      show: false,
      loading: false,
      loadingAccount: false,
      showAddBankModel: false,
      showModelGenDevice: false,
      showModelEditData: false,
      open: false,
      showLoginQRModel: false,
      loadingQR: false,
      openPopconfirm: 0,
      dropdownPlacement: "bottomRight",
      dataLoginQR: null,
      showBTNconfirmQR: true,
      showModalTrueWalletGuide: false,

      // Data States
      isData: null,
      itemLoginQR: null,
      qrValue: "https://kbiz.kasikornbank.com/",
      dataTable: [],
      formData: { username: "", password: "" },

      // Search & Filter States
      selectedValue: "",
      tableParams: {
        pagination: { current: 1, pageSize: 10, total: 0 },
        filters: {},
        sortField: null,
        sortOrder: null,
      },

      // Action Loading States
      switchLoadding: 0,
      switchTypePayLoadding: 0,
      selectTypeLoadding: 0,
      loadingSetTransFee: 0,
      loadingtimeinterval: 0,

      // Functional States
      isNextMinute: "",
      disabled: 0,
      valueSetTransFee: 0,
      disabledInput: true,


      idBankLoginQR: null,
      isExpired: false,
      initialTimeLeft: StringTimeLeft(), // 5 minutes in seconds
    };

    // Method Bindings
    this.handleChangeStatusBank = this.handleChangeStatusBank.bind(this);
    this.showDrawer = this.showDrawer.bind(this);
    this.showPromiseConfirm = this.showPromiseConfirm.bind(this);
    this.setTransFee = this.setTransFee.bind(this);
    this.handleDeleteAccounts = this.handleDeleteAccounts.bind(this);
    this.showPromiseConfirmStatusBank = this.showPromiseConfirmStatusBank.bind(this);

    // Debounce Methods
    this.debouncedFetcData = debounce(this.fetchData, 500);
  }

  // --- Lifecycle Methods ---

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
    if (sessionStorage.getItem("ext")) {
      sessionStorage.removeItem("ext");
      this.setState({ isNextMinute: "", disabled: 0 });
    }
    this.setState({ loading: false, activeTabKey1: "tab1" }, () => this.fetchData());
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  // --- Event Handlers ---

  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom = tableElement.getBoundingClientRect().bottom <= window.innerHeight;
      this.setState({ dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight" });
    }
  };

  fetchData = async () => {
    const { getDataBankAccount, setLoadingAccounts, setSearching, } = this.context;
    if (typeof setLoadingAccounts === 'function' && typeof getDataBankAccount === 'function') {
      setSearching(false);
      setLoadingAccounts(true);
      getDataBankAccount();
    }
  };

  // --- Modal & Drawer Controls ---

  showDrawer = (key) => this.setState({ open: true, isData: key });
  onClose = () => this.setState({ open: false, isData: null });
  showModel = () => this.setState({ showAddBankModel: true });
  showModelTrueWalletGuide = () => this.setState({ showModalTrueWalletGuide: true });
  closeModelTrueWalletGuide = () => this.setState({ showModalTrueWalletGuide: false });

  onCloseModel = () => {
    this.setState({
      showAddBankModel: false,
      showModelGenDevice: false,
      showModelEditData: false,
      isData: null,
      loadingAccount: false,
      loading: false,
      showLoginQRModel: false,
    }, () => this.handleRandomInt());
  };

  closeModel = () => {
    if (this.instance) this.instance.destroy();
    this.setState({
      selectedValue: "",
      isData: null,
      switchLoadding: 0,
      switchTypePayLoadding: 0,
      loading: false,
      show: false,
    });
  };

  // --- Bank Account Actions ---

  async handleAccountAction(postData, switchId) {
    const { getDataBankAccount, resProfileAdmin, getActiveBankAccounts } = this.context;
    const { types, accountType, details, description, data } = postData;
    const { id } = getCookie("validateMerchant") || {};

    const bank = data?.bank;

    let isNotify = ["Delete", "repair_account", "ready_account"].includes(types); // แจ้งเตือนเฉพาะ ลบ, ซ่อม, พร้อมใช้งาน

    // Validation
    if (types === "Switch_bank_type") {
      const access = ["scb", "ktb"];
      const TypeAccount = ["deposit", "withdrawal"];
      if (!access.includes(bank?.bank_id) && !TypeAccount.includes(accountType)) {
        return alert(`${t(`ตอนนี้ ไม่สามารถ เปิดเป็น verifying_account`, { bank: bank?.bankNameTh })}`);
      }
    }

    this.setState({
      loading: true,
      loadingAccount: true,
      switchLoadding: switchId,
      selectTypeLoadding: switchId
    });

    try {
      const res = await Apisetting.postIsActiveBank(postData);

      if (res.data.success) {
        sendApiTelegram_activity(res, types, details || description, resProfileAdmin);

        if ((process.env.REACT_APP_ENV !== "staging" && CONFIGMERCHENTID.includes(id)) && isNotify) {
          sendApiTelegram_activity_Support(res, types, details || description, resProfileAdmin)
        };

        showToast("success", res?.data?.message);
        this.setState({
          switchLoadding: 0,
          selectTypeLoadding: 0,
          loading: false,
          loadingAccount: false,
          selectedValue: "",
        }, () => {
          if (typeof getDataBankAccount === "function") getDataBankAccount();
          if (typeof getActiveBankAccounts === "function") getActiveBankAccounts();
        });
      }
    } catch (err) {
      console.log("API Error:", err);
      let errTxt = err?.response?.data?.message?.th || err?.response?.data?.message || err?.message;
      alert(t(errTxt || "An error occurred while processing your request."));

      this.setState({
        loading: false,
        loadingAccount: false,
        selectTypeLoadding: 0,
        switchLoadding: 0,
      });
    }
  }

  // เปลี่ยนประเภทบัญชี (Switch Account Type)
  showPromiseConfirm = async (e, param) => {
    if (!param) return showToast("error", "No information found.");
    if (param?.status_bank === "Active") return alert(t("bank_active_no_changeType"))

    const details = `${t("เปลี่ยนประเภทบัญชี")} ${param?.bank?.bank_id}, ${param?.accountName}, ${param?.accountNumber} ${t("เป็น")} ${e}`;
    const postData = {
      accountType: e,
      edit_id: param.id,
      note: e === "verifying_account" ? t("For Verify Only") : "",
      status_bank: "Inactive",
      data: param,
      run_from: e === "verifying_account" ? "mt" : "",
      description: details,
      details: details,
      types: "Switch_bank_type",
    };
    await this.handleAccountAction(postData, param.id);
  };

  // เปลี่ยนสถานะบัญชี (Repair / Ready)
  showPromiseConfirmStatusBank = async (param) => {
    if (!param) return showToast("error", "No information found.");

    const { id, accountName, bank, accountNumber, accountType, status_bank } = param;
    const bankInfo = `${bank?.bankCode || "N/A"} - ${accountNumber} - ${accountName}`;

    if (status_bank !== "Vault") {
      let repairConfirm = await SwalInputConfirm("question", t("Bank account problems?"), t("Please describe the problem in detail."));
      if (!repairConfirm.isConfirmed) return;

      const details = `เปลี่ยนสถานะ 'Vault' บัญชี (${accountType}) ${bankInfo}, Issue: ${repairConfirm.value}`;
      await this.handleAccountAction({
        status_bank: "Vault",
        note: repairConfirm.value,
        edit_id: id,
        data: param,
        details: details,
        description: `${repairConfirm.value}!`,
        types: "repair_account",
      }, id);
    } else {
      let confirm = await SwalInputConfirm("question", t("The account has been fixed."), t("Are you sure this account is ready to use?"));
      if (!confirm.isConfirmed) return;

      const details = `แจ้งบัญชี (${accountType}) ${bankInfo} พร้อมใช้งานแล้ว`;
      await this.handleAccountAction({
        status_bank: "Inactive",
        note: confirm.value,
        edit_id: id,
        data: param,
        description: details,
        details: details,
        types: "ready_account",
      }, id);
    }
  };

  // ลบบัญชีธนาคาร (Delete Bank Account)
  handleDeleteAccounts = async (params) => {
    if (!params) return alert("No information found.");
    if (params.status_bank === "Active") return alert(t("You cannot delete active accounts."));

    const { id, accountName, bank, accountNumber, accountType } = params;
    const bankInfo = `${bank?.bankCode || "N/A"} - ${accountNumber} - ${accountName}`;

    let repairConfirm = await SwalInputConfirm("question", t("Do you want to delete this account?"), t("Please provide a reason."));
    if (repairConfirm.isConfirmed) {
      const details = `ลบบัญชี (${accountType}) ${bankInfo}, เนื่องจาก: ${repairConfirm?.value || ""}`;
      this.handleAccountAction({
        status_bank: "Delete",
        note: repairConfirm.value,
        edit_id: id,
        data: params,
        description: details,
        details: details,
        types: "Delete",
      }, id);
    }
  };

  // เปิด/ปิดใช้งาน บัญชีธนาคาร (Active / Inactive)
  handleChangeStatusBank(e, item) {
    if (!item) return showToast("error", "No information found.");

    const { id, accountName, bank, accountNumber, accountType } = item;
    const bankInfo = `${bank?.bankCode || "N/A"} - ${accountNumber} - ${accountName}`;

    const details = `${e ? "'เปิดใช้งาน'" : "'ปิดใช้งาน'"} บัญชี (${accountType}) ${bankInfo}`;
    this.handleAccountAction({
      status_bank: e ? "Active" : "Inactive",
      edit_id: id,
      data: item,
      description: `${e ? t("enabled") : t("disabled")}!`,
      details: details,
      types: "onSwitch",
    }, id);
  }

  handleGenDevice = async (action, values) => {

    let isConfirm = await confirmSwal("question", t("Do you want {{action}} this account", { action: t(action) }));
    if (!isConfirm) return;

    let { setLoadingAccounts } = this.context;
    let isPayload = { bankId: values.id }
    if (values?.id) {
      if (typeof setLoadingAccounts === "function") setLoadingAccounts(true);
      if (action === "Verify Maker") isPayload.isVerifyIP = true
      try {
        Apibank.ktb_request_otp(isPayload)
          .then((res) => {
            if (res.status === 200) {
              let payload = { ...res?.data, ...values };
              let tel = res?.data?.telephoneNumber || res?.telephoneNumber || null;
              let telephoneNumber = tel ? tel.replace(/.(?=.{4})/g, "*") : null;
              let noteTxt = telephoneNumber ? `${t("รหัส OTP ได้ถูกส่งไปยังหมายเลขโทรศัพท์ {{telephoneNumber}} เรียบร้อยแล้ว", { telephoneNumber: telephoneNumber })}` : t("OTP has been sent successfully.");
              if (typeof setLoadingAccounts === "function") setLoadingAccounts(false);
              this.setState({ showModelGenDevice: true, isData: payload, }, () => openNotification("success", `Send OTP`, noteTxt));
            }
          })
          .catch((error) => {
            console.warn("error:", error);
            let errTxt = error.message;
            if (error?.response?.data) {
              errTxt = error?.response?.data?.message;
            }
            this.setState({ showModelGenDevice: false });
            openNotification("error", `error_code: ${error.status}`, t(errTxt));
            if (typeof setLoadingAccounts === "function") setLoadingAccounts(false);

          });
      } catch (error) {
        console.log("error:", error);
        openNotification("error", `error_code: ${error.status}`, error?.message || "error",);
        this.setState({ showModelGenDevice: false });
        if (typeof setLoadingAccounts === "function") setLoadingAccounts(false);
      }
    }
  };

  getKbizLoginQR = async () => {
    let { itemLoginQR } = this.state;

    let { id } = itemLoginQR || {};

    if (!id) return showToast("error", "No information found.");

    try {
      const res = await Apibank.get_kbiz_login_qr({ bankId: id });
      if (res.status === 200) {
        this.setState({ dataLoginQR: res.data, showLoginQRModel: true, itemLoginQR: res.data, initialTimeLeft: StringTimeLeft(), });
      } else {
        throw new Error(res.data?.message || "Failed to get QR code.");
      }
    } catch (error) {
      console.error("Error fetching QR code:", error);
      showToast("error", error.message || "An error occurred while fetching the QR code.");
      this.setState({ loadingAccount: false });
    } finally {
      this.setState({ loadingAccount: false });
    }
  }

  getConfirmKbizLoginQR = async (id) => {
    if (!id) return showToast("error", "No information found.");
    this.setState({ loadingAccount: true, });

    try {
      const res = await Apibank.get_confirm_kbiz_login_qr({ bankId: id });
      if (res.status === 200) {
        showToast("success", res?.data?.message || "Login successful.");
        this.setState({ loadingAccount: false, showLoginQRModel: false, itemLoginQR: null, isExpired: false, initialTimeLeft: StringTimeLeft() }, () => { this.context.getDataBankAccount(); this.onCloseModel() });
      } else {
        throw new Error(res.data?.message || "Failed to get QR code.");
      }
    } catch (error) {
      console.error("Error fetching QR code:", error);
      showToast("error", error.message || "An error occurred while fetching the QR code.");
      this.setState({ loadingAccount: false, showLoginQRModel: false, });
    } finally {
    }
  }


  // รับข้อมูลจากการกด ล็อคเอาท์ในตาราง แล้วเปิด Modal QR Code
  handleLogoutQr = async (values) => {
    const { id } = values || {};

    if (!id) {
      return showToast("error", "No information found.");
    }

    const isConfirm = await confirmSwal("question", t("You want to log out of this bank account"), t("*If you confirm the logout of this bank account, you will need to log in again."));
    if (!isConfirm) return;

    this.setState({ loadingAccount: true });

    try {
      const res = await Apibank.get_kbiz_logout_qr({ bankId: id });

      if (res?.status === 200) {
        await this.context.getDataBankAccount();
      } else {
        throw new Error(res?.data?.message || "Failed to get QR code.");
      }
    } catch (error) {
      console.error("Error fetching QR code:", error);
      showToast("error", error.message || "An error occurred while fetching the QR code.");
    } finally {
      this.setState({ loadingAccount: false });
    }
  };


  // รับข้อมูลจากการกด ล็อคอินในตาราง แล้วเปิด Modal QR Code
  handleLoginQr = async (values) => {
    if (!values) return showToast("error", "No information found.");
    this.setState({ loadingAccount: true })
    setTimeout(() => {
      this.setState({ itemLoginQR: values, idBankLoginQR: values?.id }, () => this.getKbizLoginQR());
    }, 500);
  }

  onConfirmQr = async () => {

    this.setState({ loadingAccount: true });
    let { idBankLoginQR } = this.state;

    if (!idBankLoginQR) return showToast("error", "No information found.");
    await this.getConfirmKbizLoginQR(idBankLoginQR);
  }
  onRefreshQr = async () => this.setState({ loadingAccount: true }, () => this.getKbizLoginQR());

  // --- Specialized Settings ---

  // ตั้งค่าธรรมเนียมฝาก (Transaction Fee) สำหรับบัญชีธนาคารฝาก
  setTransFee = async (item, value) => {
    if (!CheckAdminType("setTransFee")) return alert("Unauthorized access.");
    if (!item?.id) return showToast("error", "No information found.");

    const { id, accountName, bank, accountNumber, accountType } = item;
    const { getDataBankAccount, resProfileAdmin } = this.context;

    this.setState({ loadingSetTransFee: id, openPopconfirm: id, disabledInput: true });

    const bankInfo = `${bank?.bankCode || "N/A"} - ${accountNumber} - ${accountName}`;
    const details = `ตั้งค่า ค่าธรรมเนียมบัญชี (${accountType}) ${bankInfo}`;

    try {
      const res = await Apisetting.postIsActiveBank({
        edit_id: id,
        transFee: value,
        types: "transFee",
        data: item,
        description: details,
      });

      sendApiTelegram_activity(res, "transFee", details, resProfileAdmin);

      if (res.status === 200) {
        showToast("success", res.data.message || "บันทึกสำเร็จ");
        setTimeout(() => {
          this.setState({ loadingSetTransFee: 0, openPopconfirm: 0, valueSetTransFee: 0 },
            () => { if (getDataBankAccount) getDataBankAccount(); });
        }, 1500);
      } else {
        throw new Error(res.data.message);
      }
    } catch (error) {
      showToast("error", error.message || "Technical error occurred.");
      this.setState({ loadingSetTransFee: 0, disabledInput: false });
    }
  };

  // ฟังก์ชันเช็คยอดเงิน
  getBalance = async (id) => {
    const extS = 120000;
    const disabledOnTime = await getNextMinute(extS);

    this.setState({ switchLoadding: id, disabled: id, isNextMinute: disabledOnTime }, async () => {
      const res = await getFuncBalance(id);
      this.setState({ switchLoadding: 0 });
      sessionStorage.setItem("ext", `${new Date()}`);
      if (res) this.context.getDataBankAccount();
      setTimeout(() => {
        this.setState({ disabled: 0, isNextMinute: "" });
        sessionStorage.removeItem("ext");
      }, extS);
    });
  };

  // ตั้งเวลาดึงยอดฝาก (Time Interval) สำหรับบัญชีธนาคาร
  setTimeinterval = async (e, item) => {
    if (!item?.id || !e) return alert("ข้อมูลไม่ครบถ้วน");

    const { getDataBankAccount, resProfileAdmin } = this.context;
    this.setState({ loadingtimeinterval: item.id });

    const minutes = parseFloat(e);
    const details = `ตั้งเวลาดึงยอดฝากเป็น ${minutes} ${t("minutes")}`;

    try {
      const res = await Apisetting.postIsActiveBank({
        edit_id: item.id,
        types: "timeInterval",
        timeInterval: minutes,
        data: item,
        description: details,
      });
      sendApiTelegram_activity(res, "timeInterval", details, resProfileAdmin);
      if (res.status === 200) {
        showToast("success", res.data.message);
        setTimeout(() => {
          this.setState({ loadingtimeinterval: 0 }, () => getDataBankAccount());
        }, 1000);
      }
    } catch (error) {
      showToast("error", error.message);
      this.setState({ loadingtimeinterval: 0 });
    }
  };

  // --- Simple Handlers ---
  onChange = (e) => this.setState({ selectedValue: e.target.value });
  onUpdateAuto = () => this.setState({ loading: false }, () => this.context.getDataBankAccount());
  showPopconfirm = (id) => this.setState({ openPopconfirm: id });
  onChangeSetTransFee = (value) => this.setState({ valueSetTransFee: parseFloat(value), disabledInput: false });
  handleCancelPopconfirm = () => this.setState({ openPopconfirm: 0, loadingSetTransFee: 0, valueSetTransFee: 0, disabledInput: true });
  handleEditData = (record) => record?.status_bank === "Active" ? alert(t("bank_active_no_edit")) : this.setState({ showModelEditData: true, isData: record });
  handleChangeTab = (event) => {
    this.setState((prevState) => ({
      tableParams: {
        ...prevState.tableParams,
        pagination: { ...prevState.tableParams.pagination, current: 1 },
      },
    }), () => this.context.onChangeTab(event));
  }

  setStateShowModelQR = (state) => this.setState({ showLoginQRModel: false, loadingAccount: false, showBTNconfirmQR: true, isExpired: false, initialTimeLeft: StringTimeLeft });


  // ฟังก์ชันทำงานเมื่อเวลานับถอยหลังเหลือ 0 (หมดเวลา)
  handleCountdownFinish = () => {
    this.setState({ isExpired: true });
  };

  handleRandomInt = () => {
    this.context.onRandomInt();
  };

  render() {
    // 1. Context & Props Destructuring
    const {
      allBankAccountData,
      loadingBankAccounts,
      keyTab,
      getDataBankAccount,
      counterAccount,
      resAllDataMerchang,
      nameMerchang,
      resBankGroupData,
      isMerchantData,
      resProfileAdmin,
      merchantId,
      isMobile,
      handleChangStatus,
      handleChangType,
      typeBank,
      statusBank,
      handleTableChange,
      tableParams,
      isSearching,
      onTypeChange,
      onSearch,
      searchType,
      onChangeEnabled,
      enabled_verify_hub,
      webHookUrl_wallet,
      randomInterval
    } = this.context;

    const { t, i18n, history } = this.props;
    const currentLanguage = i18n.language;


    let webHookUrl = `${webHookUrl_wallet}${randomInterval}`;

    // 2. State & Local Methods Destructuring
    const {
      isData,
      open,
      loading,
      showAddBankModel,
      switchLoadding,
      switchTypePayLoadding,
      showModelGenDevice,
      loadingtimeinterval,
      disabled,
      isNextMinute,
      loadingSetTransFee,
      openPopconfirm,
      valueSetTransFee,
      disabledInput,
      loadingAccount,
      showModelEditData,
      selectTypeLoadding,
      dropdownPlacement,
      showModalTrueWalletGuide,
      showLoginQRModel, dataLoginQR, showBTNconfirmQR, isExpired, initialTimeLeft
    } = this.state;

    // 5. Permissions
    const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];
    const canAddBank = hasPermission(userPermissions, "add");
    const canDelBank = hasPermission(userPermissions, "del");
    const canEditAdvancedBank = hasPermission(userPermissions, "edit_advanced");
    const canEditBank = hasPermission(userPermissions, "edit");
    const canDetailsBank = hasPermission(userPermissions, "details");
    const canChangStatusBank = hasPermission(userPermissions, "changeStatus");
    const canChangTypeBank = hasPermission(userPermissions, "changeType");
    const canSetIntervalBank = hasPermission(userPermissions, "setInterval");
    const canOn_OffBank = hasPermission(userPermissions, "on_off");
    const canSetFeeBank = hasPermission(userPermissions, "setFee");

    const columnsCurrent = ColumnsCurrent(
      this.handleChangeStatusBank,
      switchLoadding,
      this.showDrawer,
      this.showPromiseConfirm,
      this.showPromiseConfirmStatusBank,
      this.handleDeleteAccounts,
      this.getBalance,
      switchTypePayLoadding,
      dropdownPlacement,
      this.handleGenDevice,
      this.setTimeinterval,
      loadingtimeinterval,
      history,
      disabled,
      isNextMinute,
      this.setTransFee,
      loadingSetTransFee,
      this.showPopconfirm,
      openPopconfirm,
      this.handleCancelPopconfirm,
      valueSetTransFee,
      this.onChangeSetTransFee,
      disabledInput,
      this.handleEditData,
      selectTypeLoadding,
      currentLanguage,
      resProfileAdmin,
      canAddBank,
      canDelBank,
      canEditAdvancedBank,
      canEditBank,
      canDetailsBank,
      canChangStatusBank,
      canSetIntervalBank,
      canOn_OffBank,
      canSetFeeBank,
      canChangTypeBank,
      enabled_verify_hub,
      onChangeEnabled,
      this.handleLoginQr,
      this.handleLogoutQr,
    );

    const columnsVerify = ColumnsVerify(
      this.handleChangeStatusBank,
      this.showPromiseConfirm,
      this.handleDeleteAccounts,
      switchLoadding,
      this.showDrawer,
      dropdownPlacement,
      tableParams,
      disabled,
      isNextMinute,
      this.getBalance,
      this.handleEditData,
      selectTypeLoadding,
      currentLanguage,
      resProfileAdmin,
      canDelBank,
      canEditAdvancedBank,
      canEditBank,
      canDetailsBank,
      canOn_OffBank,
      canChangTypeBank,
      enabled_verify_hub,
      onChangeEnabled
    );

    const columnsRepair = ColumnsRepair(
      this.handleDeleteAccounts,
      this.showPromiseConfirmStatusBank,
      this.showDrawer,
      dropdownPlacement,
      tableParams,
      this.handleEditData,
      selectTypeLoadding,
      currentLanguage,
      resProfileAdmin,
      canDelBank,
      canEditAdvancedBank,
      canEditBank,
      canDetailsBank,
      canChangStatusBank,
    );
    const { total } = tableParams?.pagination || {};

    const columnsSuspended = ColumnsSuspended(this.showDrawer, tableParams, selectTypeLoadding, currentLanguage, resProfileAdmin, canDetailsBank,);

    // 4. Tab & Content Logic
    const tabList = renderTabtList(t, counterAccount, statusBank, isSearching, total, this.debouncedFetcData);

    const contentList = renderContentList({
      t,
      columnsCurrent,
      columnsVerify,
      columnsRepair,
      columnsSuspended,
      allBankAccountData,
      loadingBankAccounts,
      tableParams,
      handleTableChange: handleTableChange,
      showModel: this.showModel,
      typeBank,
      statusBank,

    });


    return (
      <>
        {/* --- Modals Section --- */}
        <DetailsBank
          open={open}
          isData={isData}
          onClose={this.onClose}
          showPromiseConfirmStatusBank={this.showPromiseConfirmStatusBank}
          handleDeleteAccounts={this.handleDeleteAccounts}
          loading={loading}
          resAllDataMerchang={resAllDataMerchang}
          history={history}
          nameMerchang={nameMerchang}
          resBankGroupData={resBankGroupData}
        />

        <AddBankModel
          show={showAddBankModel}
          handleClose={this.onCloseModel}
          getDataBankAccount={getDataBankAccount}
          isMerchantData={isMerchantData}
          resProfileAdmin={resProfileAdmin}
          merchantId={merchantId}
          t={t}
          getConfirmKbizLoginQR={this.getConfirmKbizLoginQR}
          loadingAccount={loadingAccount}
          webHookUrl_wallet={webHookUrl}
          ModelTrueWalletGuide={this.showModelTrueWalletGuide}
        />

        <LoginQRCodeCard
          show={showLoginQRModel}
          qrValue={dataLoginQR?.qrCode}
          data={dataLoginQR}
          initialTimeLeft={initialTimeLeft}
          loading={loadingAccount}
          onConfirm={this.onConfirmQr}
          setStateShowModelQR={this.setStateShowModelQR}
          onRefreshQr={this.onRefreshQr}
          showBTNconfirmQR={showBTNconfirmQR}
          t={t}
          isExpired={isExpired}
          handleCountdownFinish={this.handleCountdownFinish}
        />

        <EditDataModel
          show={showModelEditData}
          handleClose={this.onCloseModel}
          isData={isData}
          getDataBankAccount={getDataBankAccount}
          resProfileAdmin={resProfileAdmin}
          merchantId={merchantId}
          t={t}
          canEditBank={canEditBank}
          canEditAdvancedBank={canEditAdvancedBank}
        />

        <GenDeviceModel
          isData={isData}
          show={showModelGenDevice}
          handleClose={this.onCloseModel}
          fetchData={this.fetchData}
          t={t}
        />

        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />


        <Modal
          maskClosable={false}
          title={t('hero.badge')}
          zIndex={9999}
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={showModalTrueWalletGuide}
          onCancel={this.closeModelTrueWalletGuide}
          style={{ top: 20 }}
         footer={[]}
          
          width={isMobile ? "90%" : 800}
        >
          <TrueWalletGuide t={t} webHookUrl_wallet={webHookUrl} />
        </Modal>

        {/* --- Main UI Section --- */}
        <Spin spinning={loadingAccount}>
          <div className="container-fluid" style={{ flex: 1 }}>
            <PageHeader
              HeaderText={t("Manage Accounts")}
              Breadcrumb={[
                {
                  name: removeSlashesFromPath(window.location.pathname),
                  navigate: window.location.pathname,
                },
              ]}
            />

            <br className="sm-hiden" />

            <Card
              title={canAddBank ? <Space style={{ gap: 5 }}>
                <Button
                  icon={<BankOutlined />}
                  onClick={() => {
                    if (!canAddBank) return alert(t("Sorry, You don't have permission to add bank account"));
                    this.showModel();
                  }}
                >
                  {t("add")}
                </Button>
              </Space> : null}
              extra={<ComponentSearch searchType={searchType} onSearch={onSearch} loadingBankAccounts={loadingBankAccounts} onTypeChange={onTypeChange} t={t} />}
              tabList={tabList}
              activeTabKey={keyTab}
              onTabChange={this.handleChangeTab}
            >
              {/* --- Table Render Logic --- */}
              <Flex justify="end" wrap={isMobile ? false : true} style={{ gap: isMobile ? 8 : 0 }}>

                {/* STATUS */}
                <div style={{ margin: 8, padding: 8, opacity: 0.9 }}>
                  <p className="mb-0" style={{ marginLeft: 5 }}><FilterOutlined /> {t('status_account')}</p>
                  <Select
                    // prefix={`${t("Status")}: `}
                    status="warning"
                    value={statusBank}
                    loading={loadingBankAccounts}
                    style={{ width: isMobile ? 150 : 200 }}
                    onChange={handleChangStatus}
                    options={[
                      {
                        label: <span>{t('Status')}</span>,
                        title: t('Status'),
                        options: [
                          { value: 'all', label: t('all') },
                          { value: 'Active', label: t('Active') },
                          { value: 'Inactive', label: t('Inactive') },
                          { value: 'PendingDevice', label: t('PendingDevice') },
                          { value: 'LoginQR', label: t('Login-Qr') },
                          { value: 'Vault', label: t('Vault') },
                          { value: 'Banned', label: t('Banned') },
                          { value: 'Delete', label: t('Delete') },
                        ],
                      },

                    ]}
                  />
                </div>

                {/* TYPE */}
                <div style={{ margin: 8, padding: 8, opacity: 0.9 }}>
                  <p className="mb-0" style={{ marginLeft: 5 }}><FilterOutlined /> {t('type_account')}</p>
                  <Select
                    // prefix={`${t("Type")}: `}
                    status="warning"
                    value={typeBank}
                    style={{ width: isMobile ? 150 : 200 }}
                    loading={loadingBankAccounts}
                    onChange={handleChangType}
                    options={[
                      {
                        label: <span>{t('Type')}</span>,
                        title: t('Type'),
                        options: [
                          { value: 'all', label: t('all') },
                          { value: 'deposit', label: t('deposit') },
                          { value: 'withdrawal', label: t('withdrawal') },
                          { value: 'verifying_account', label: t('verifying_account') },
                        ],
                      },

                    ]}
                  />
                </div>
              </Flex>
              {contentList[keyTab]}
              {/* --- Footer Note --- */}
              <FooterBankAccount t={t} />
            </Card>
          </div>
        </Spin>
      </>
    );
  }
}
export default connect(null, {},)(withTranslation()(ManageBankAccount));
